import { FormProvider, useForm } from "react-hook-form";
import { WorkAgreementDocument } from "../../../orders/editOrder/long/workAgreement/sections/workAgreementDocument/WorkAgreementDocument";
import { useAppSelector } from "../../../../app/hooks";
import { useEffect } from "react";

export const WorkAgreementDocumentSection = () => {
  const employment = useAppSelector((state) => state.employment.additionalInfo);

  const methods = useForm({
    defaultValues: {
      workAgreementDocumentId: employment?.workAgreementDocumentId,
    },
    mode: "onChange",
  });

  useEffect(() => {
    methods.reset({
      workAgreementDocumentId: employment?.workAgreementDocumentId,
    });
  }, [employment?.workAgreementDocumentId, methods]);

  return (
    <FormProvider {...methods}>
      <WorkAgreementDocument
        talentId={employment?.talentId}
        isReadOnly={true}
        titleWidth={2}
        contentWidth={10}
      />
    </FormProvider>
  );
};
